import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import LottieComponent from "../../atoms/LottieComponent";

/**
 * FreeDeliveryChip - A chip for free delivery with a Lottie delivery icon
 * @returns {JSX.Element}
 */
const FreeDeliveryChip = () => {
  const { scooterIconUrl } = useSelector(
    (state) => ({
      scooterIconUrl: state?.lottieIcons?.icons?.scooter?.iconUrl,
    }),
    shallowEqual,
  );

  return (
    <div
      id="freeTagWrapper"
      className="inline-flex h-28 w-fit shrink-0 items-center gap-4 rounded-4 bg-[#EBF6EB] px-6 py-6 text-10 font-bold uppercase text-offer-900"
    >
      Free Delivery
      {scooterIconUrl && (
        <span className="h-24 w-24">
          <LottieComponent animationPath={scooterIconUrl} />
        </span>
      )}
    </div>
  );
};

export default FreeDeliveryChip;
